import React from 'react';
import styled from 'styled-components'
const Wrapper = styled.div`
    .button {
        color: #000;
        background-color: #fff;
        font-size: 22px;
        border-radius: 999px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 32px;
        min-width: 144px;
        transition: background-color 0.15s linear;
        margin-top: 40px;
        font-weight: 700;
    }
`
const Connected = () => {
    return (
        <Wrapper>
            <button type="button" class="button">Connected</button>
        </Wrapper>
    );
};

export default Connected;